import React from 'react'
import { Stack, Text, Title } from '@mantine/core'

type Props = {
    title: string
    description?: string
}

const ModalHeader = ({ title, description }: Props) => {
    return (
        <Stack spacing="xs">
            <Title order={2} color="gray.8">
                {title}
            </Title>
            <Text component="span" color="gray.6" size="xs" weight="normal">
                {description}
            </Text>
        </Stack>
    )
}

export default ModalHeader
